<template>
  <div class="account">
    <ul class="pub_nav">
      <li :class="{active:$route.path.indexOf('/personal_center/safe')>-1}">
        <a>账号安全</a>
      </li>
    </ul>
    <div class="box">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  created() {
    
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
@import "../index.scss";
.account{
    .box{
        background: #fff;
        padding: 30px 30px 0;
        box-sizing: border-box;
        margin-top: 30px;
    }
}
</style>